import React from "react";
import { Container, Image } from "semantic-ui-react";
import { TopBar  } from "../../components/Web";
import { image } from "../../assets";
import "./ClientLayout.scss";

export function ClientLayout(props) {
  const { children } = props;

  return (
    <div className="client-layout">
      <div className="client-layout__header">
        <TopBar showExitIcon={props.showExitIcon}/>
      </div>

      <div className="client-layout__content">
        {children}
      </div>

      <div className="client-layout__footer">
        <Container>
          <span className="ft"> <Image src={ image.vigilado }/></span>
          <span className="ft">Todos los derechos reservados © Colsubsidio 2024</span>
        </Container>
      </div>
    </div>
  );
}
